import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

// import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./Elements/ScrollToTop/scroll_top";

import "./App.css";
import Header from "./Elements/Header/header";
import Footer from "./Elements/Footer/footer";
import Home from "./pages/Home";
import MeetOurStaff from "./pages/MeetOurStaff/our-staff";
import TeamMemberFullDetails from "./pages/StaffDetails/teamMemberFullDetails";
import Purchase from "./pages/Purchase/purchase";
import PaperWork from "./pages/Paperwork/paper-work";
import QuickQuote from "./pages/QuickQuote/quick-quote";
import FHA from "./pages/FHA_Loans/fha";
import VALoans from "./pages/VA_Loans/va-loans";
import MonthlyPaymentMortgageCalculator from "./pages/MonthlyPaymentCalculator/what-will-my-monthly-payment-be-calculator";
import AffordabilityCalculator from "./pages/AffordabilityCalculator/how-much-can-i-afford-calculator";
import Refinancing from "./pages/Refinancing/refinancing";
import CashOutRefinance from "./pages/CashOutRefinance/cash-out-refinance";
import FhaVaStreamline from "./pages/FhaVaStreamlineRefinance/fha-va-streamline";
import TheLoanProcess from "./pages/TheLoanProcess/the-loan-process";
import GlossaryOfMortgageTerms from "./pages/GlossaryOfMortgageTerms/glossary-terms";
import AboutUs from "./pages/AboutUs/about-us";
import ContactUs from "./pages/ContactUs/contact-us";
import GetInformativeFreeReports from "./pages/GetInformativeFreeReports/free-reports";
import RefinanceAnalysisCalculator from "./pages/RefinanceAnalysisCalculator/refinance-analysis-calculator";
import DebtConsolidationCalculator from "./pages/ConsolidationCalculator/debt-consolidation-calculator";
import RentingVsBuyingCalculator from "./pages/RentingVsBuyingCalculator/renting-versus-buying-calculator";
import AdaAccessibilityStatement from "./pages/adaAccessibilityStatement/ada-accessibility-statement";
import PrivacyPolicyStatement from "./pages/PrivacyStatement/privacy-policy";
import CommunicationPolicy from "./pages/CommunicationPolicy/communication-policy";
import TestimonialsReview from "./pages/TestimonialReview/testimonials";
import RightLoanForYou from "./pages/WhichLoanIsRightForYou/which-loan-is-right-for-me";
import TappingYourEquityAfterRateCuts from "./pages/blogPages/TappingYourEquityAfterRateCuts/tapping_your_equity_after_rate_cuts";
import FederalReserveRateCuts from "./pages/blogPages/FederalReserveRateCuts/federal_reserve_rate_cuts";
import RefiIntoA15YearMortgage from "./pages/blogPages/RefiIntoA15YearMortgage/refi_into_a_15_year_mortgage";
import HowTheFedAffectsMortgageRates from "./pages/blogPages/HowTheFedAffectsMortgageRates/how_the_fed_affects_mortgage_rates";
import WhatIsAZombieMortgage from "./pages/blogPages/WhatIsAZombieMortgage/what_is_a_zombie_mortgage";

import DebtServiceCoverageRatioLoansBlog from "./pages/blogPages/DebtServiceCoverageRatioLoansBlog/debt_service_coverage_ratio_loans";
import AdjustableRateMortgageBlog from "./pages/blogPages/AdjustableRateMortgageBlog/adjustable_rate_mortgage";
import UnderstandingEscrowsInTheMortgageIndustryBlog from "./pages/blogPages/UnderstandingEscrowsInTheMortgageIndustryBlog/understanding_escrows_in_the_mortgage_industry";

import JoinTheTeam from "./pages/JoinTheTeam/joinTheTeam";
import TodaysRates from "./pages/TodaysRates/todaysRates";
import AllCalculators from "./pages/Calculators/allCalculators";
import BuyDone from "./pages/BuyDownCalculator/buydone";
import Home2 from "./pages/Home/2";
import ConventionalLoans from "./pages/ConventionalLoans/conventionalLoans";
import LoanForInvestors from "./pages/LoanForInvestors/loanForInvestors";
import LoansForSelfEmployed from "./pages/LoansForSelfEmployed/loansForSelfEmployed";
import DebtServiceCoverageRatioLoans from "./pages/DebtServiceCoverageRatioLoans/debtServiceCoverageRatioLoans";
import AdjustableRateMortgage from "./pages/AdjustableRateMortgage(ARM)/adjustableRateMortgage";
import UnderstandingEscrowsInTheMortgageIndustry from "./pages/UnderstandingEscrowsInTheMortgageIndustry/understandingEscrowsInTheMortgageIndustry";
import Learn from "./pages/Learn/learn";
import SecurityProtection from "./Elements/SecurityProtection/securityProtection";
// import ClientReview from "./pages/Client_Review/clientReview";

function RouteChangeLoader({ children }) {
  const location = useLocation();
  const [loadingRoute, setLoadingRoute] = useState(false);

  useEffect(() => {
    setLoadingRoute(true);

    const timer = setTimeout(() => {
      setLoadingRoute(false);
    }, 1500); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, [location]);

  if (loadingRoute) {
    return (
      <div className="loading-screen">
        <h2>Loading...</h2>
        <div className="spinner" />
      </div>
    );
  }

  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SecurityProtection />
        <ScrollToTop />
        <Header />
        <RouteChangeLoader>
          <Routes>
            <Route path="/2" element={<Home />} />
            <Route path="/" element={<Home2 />} />

            <Route path="/our-family" element={<MeetOurStaff />} />
            <Route path="/our-family/:id" element={<TeamMemberFullDetails />} />

            <Route path="/learn" element={<Learn />} />
            {/* <Route path="/client-reviews" element={<ClientReview />} /> */}
            <Route path="/join-our-family" element={<JoinTheTeam />} />

            <Route path="/conventional-loans" element={<ConventionalLoans />} />
            <Route path="/loan-for-investors" element={<LoanForInvestors />} />
            <Route
              path="/loans-for-self-employed"
              element={<LoansForSelfEmployed />}
            />
            <Route
              path="/dscr-loans"
              element={<DebtServiceCoverageRatioLoans />}
            />
            <Route
              path="/adjustable-rate-mortgage"
              element={<AdjustableRateMortgage />}
            />
            <Route
              path="/understanding-escrows-in-the-mortgage-industry"
              element={<UnderstandingEscrowsInTheMortgageIndustry />}
            />
            <Route path="/todays-rates" element={<TodaysRates />} />
            <Route path="/calculators" element={<AllCalculators />} />
            <Route path="/buy-down" element={<BuyDone />} />

            <Route path="/paper-work" element={<PaperWork />} />
            <Route path="/quick-quote" element={<QuickQuote />} />
            <Route
              path="/how-much-can-i-afford-calculator"
              element={<AffordabilityCalculator />}
            />
            <Route
              path="/what-will-my-monthly-payment-be-calculator"
              element={<MonthlyPaymentMortgageCalculator />}
            />
            <Route path="/fha" element={<FHA />} />
            <Route path="/va-loans" element={<VALoans />} />
            <Route path="/purchase" element={<Purchase />} />
            <Route path="/refinancing" element={<Refinancing />} />
            <Route path="/cash-out-refinance" element={<CashOutRefinance />} />
            <Route
              path="/refinance-analysis-calculator"
              element={<RefinanceAnalysisCalculator />}
            />
            <Route
              path="/debt-consolidation-calculator"
              element={<DebtConsolidationCalculator />}
            />
            <Route
              path="/renting-versus-buying-calculator"
              element={<RentingVsBuyingCalculator />}
            />
            <Route path="/fha-va-streamline" element={<FhaVaStreamline />} />
            <Route path="/the-loan-process" element={<TheLoanProcess />} />
            <Route
              path="/free-reports"
              element={<GetInformativeFreeReports />}
            />
            <Route
              path="/glossary-terms"
              element={<GlossaryOfMortgageTerms />}
            />
            <Route path="/about-us" element={<AboutUs />} />

            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/testimonials" element={<TestimonialsReview />} />
            <Route
              path="/which-loan-is-right-for-me"
              element={<RightLoanForYou />}
            />
            <Route
              path="/ada-accessibility-statement"
              element={<AdaAccessibilityStatement />}
            />
            <Route
              path="/privacy-policy"
              element={<PrivacyPolicyStatement />}
            />
            <Route
              path="/communication-policy"
              element={<CommunicationPolicy />}
            />
            <Route
              path="/tapping_your_equity_after_rate_cuts"
              element={<TappingYourEquityAfterRateCuts />}
            />
            <Route
              path="/federal_reserve_rate_cuts"
              element={<FederalReserveRateCuts />}
            />
            <Route
              path="/refi_into_a_15_year_mortgage"
              element={<RefiIntoA15YearMortgage />}
            />
            <Route
              path="/how_the_fed_affects_mortgage_rates"
              element={<HowTheFedAffectsMortgageRates />}
            />
            <Route
              path="/what_is_a_zombie_mortgage"
              element={<WhatIsAZombieMortgage />}
            />

            <Route
              path="/debt_service_coverage_ratio_loans"
              element={<DebtServiceCoverageRatioLoansBlog />}
            />
            <Route
              path="/adjustable_rate_mortgage"
              element={<AdjustableRateMortgageBlog />}
            />
            <Route
              path="/understanding_escrows_in_the_mortgage_industry"
              element={<UnderstandingEscrowsInTheMortgageIndustryBlog />}
            />

            {/* <Route path="/test-mail-through-form" element={<TeatingGmailFormPage />} /> */}
          </Routes>
        </RouteChangeLoader>
        <Footer />
      </BrowserRouter>
    </div>
  );
}
export default App;
